import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52caea19")

_pushScopeId("data-v-52caea19")
const _hoisted_1 = { class: "speaker-button" }
const _hoisted_2 = { class: "wrap-setting" }
const _hoisted_3 = {
  key: 0,
  class: "wrap-setting"
}
const _hoisted_4 = {
  key: 1,
  class: "wrap-setting"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toggle = _resolveComponent("Toggle")
  const _component_TitleOption = _resolveComponent("TitleOption")
  const _component_PopUpWithButton = _resolveComponent("PopUpWithButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PopUpWithButton, {
      class: "speaker-popup-wrap",
      isDefaultButton: false
    }, {
      content: _withId(({ toggleDropdown }) => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listMenu, (item) => {
            return (_openBlock(), _createBlock(_component_Button, {
              class: "item item-first",
              mode: "flat",
              icon: { spriteUrl: '/image/videoconf-icons.svg', name: item.icon, color: '--sui-gray-700', width: '25px', height: '25px'},
              size: "l",
              onClick: (() => {item.click(); toggleDropdown()})
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["icon", "onClick"]))
          }), 256))
        ]),
        (_ctx.isAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listToggles, (toggle) => {
                return (_openBlock(), _createBlock(_component_Toggle, {
                  class: "toggle-option",
                  label: toggle,
                  isLabelFirst: false,
                  size: "s"
                }, null, 8, ["label"]))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_TitleOption, {
                class: "title-setting",
                title: _ctx.t('speakerMenuList.allow')
              }, null, 8, ["title"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAllowUsers, (toggle) => {
                return (_openBlock(), _createBlock(_component_Toggle, {
                  class: "toggle-option",
                  label: toggle,
                  isLabelFirst: false,
                  size: "s",
                  modelValue: true
                }, null, 8, ["label"]))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      button: _withId(() => [
        _createVNode(_component_Button, {
          class: "bnt-setting",
          mode: "flat",
          size: "s",
          icon: { name: 'ic16-more-ver', color: '--sui-white', width: '20px', height: '20px'} ,
          "icon-only": ""
        })
      ]),
      _: 1
    })
  ]))
})